module.exports = __webpack_public_path__ + "img/video-play.6265624e.svg";